import i18n from "../../../../../shared/i18n";
import BaseModel from "../../../../../core/components/input-widget/BaseModel";

export default class TrustLevel extends BaseModel {
  uuid = null;
  name = '';
  credit_limit = null;
  threshold = null;
  exclude_from_auto_assignment = false;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  getData() {
    return {
      name: this.name,
      exclude_from_auto_assignment: !!this.exclude_from_auto_assignment,
      credit_limit: parseInt(this.credit_limit),
      threshold: parseInt(this.percent),
    };
  }

  rules = {
    credit_limit: 'required|min_value:0',
    name: 'required',
    threshold: 'required|min_value:0',
  };

  attributeLabels = {
    name: i18n.t('Name'),
    credit_limit: i18n.t('Bidding Limit'),
    threshold: i18n.t('Threshold'),
    exclude_from_auto_assignment: i18n.t('Exclude from auto assignment')
  };
}
